<app-header1></app-header1>
<div class="wel-main">
  <div class="banner">
    <!-- <video src="https://cdn.virtueanalytics.com/cache/top5-colleges-student-banner.mp4" width="100%" height="300px"></video> -->
    <div
      class="container-fluid d-flex flex-lg-row flex-sm-column flex-column justify-content-center align-items-center"
    >
      <div class="w-50 w-md-100">
        <div class="container">
          <div class="">
            <!-- <div class="d-flex flex-row justify-content-start mb-2 ">
            <h1 class="">Top5 Colleges</h1>
          </div> -->
            <p class="col-10">
              The Top5 Colleges tool provides college aspiring students and
              their families with a tabulated comparison of scholarships
              available for their choice of colleges.
              <span>Choose Wisely! </span>
            </p>
          </div>
          <div class="login-expired" *ngIf="isExpireLogin">
            <div class="text-danger">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 err-icon"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                />
              </svg>
              <h5 class="inline-block">login access has been expired</h5>
            </div>
            <!-- <div class="clickto">
              Please
              <span
                ><a (click)="openModelExtend()" class="click-h"
                  >click here</a
                ></span
              >
              to extend login hours
            </div> -->
            <div class="clickto">
              Please Pay & Subscribe
              <!-- <span
                ><a (click)="openModelExtend()" class="click-h"
                  >click here</a
                ></span
              > -->
            </div>
          </div>
        </div>
      </div>
      <div class="w-50">
        <div class="d-flex flex-row justify-content-around">
          <div class="bg-white student-login main">
            <!-- <h1>Student {{Studenttext}}</h1>  -->
            <tui-tabs style="box-shadow: none !important">
              <button
                class="tabs"
                [ngClass]="{ tab1: alreadyAccount == true }"
                tuiTab
                (click)="showData('tab1')"
              >
                Student Sign Up
              </button>
              <!-- <button
                class="tabs"
                [ngClass]="{ tab2: alreadyAccount == false }"
                tuiTab
                (click)="showData('tab2')"
              >
                Student Sign In
              </button> -->
            </tui-tabs>
            <!-- <tui-tabs
              *ngIf="WithoutCoupenCode"
              [(activeItemIndex)]="activeItemIndex"
              style="box-shadow: none !important"
            >
              <button class="tabs" style="color: #f2692e !important" tuiTab>
                Student Sign Up
              </button>
            </tui-tabs> -->

            <div class="Signup" *ngIf="alreadyAccount == true">
              <form #myForm="ngForm" (ngSubmit)="submit(myForm)">
                <div class="Student Login row">
                  <div class="form-group fm-row col-md-6">
                    <label for="Student Name">First Name</label>
                    <input
                      placeholder="Student's Name"
                      autocomplete="off"
                      type="text"
                      class="form-control"
                      pattern="[a-zA-Z][a-zA-Z ]*"
                      #name="ngModel"
                      [(ngModel)]="model.firstName"
                      name="firstName"
                      [ngClass]="{
                        'is-invalid': myForm.submitted && name.invalid
                      }"
                      required
                      (onmouseleave)="handleuserfirst($event)"
                      (keyup)="handleuserfirst($event)"
                      (keypress)="handleuserfirst($event)"
                    />
                    <div
                      *ngIf="validitionfirstName"
                      class="text-danger mt-1 error"
                    >
                      {{ validitionfirstName }}
                    </div>
                  </div>
                  <div class="form-group fm-row col-md-6">
                    <label for="Student Name">Last Name</label>
                    <input
                      placeholder="Student's Name"
                      autocomplete="off"
                      type="text"
                      class="form-control"
                      pattern="[a-zA-Z][a-zA-Z ]*"
                      #name="ngModel"
                      [(ngModel)]="model.lastName"
                      name="lastName"
                      [ngClass]="{
                        'is-invalid': myForm.submitted && name.invalid
                      }"
                      required
                      (onmouseleave)="handleuserlast($event)"
                      (keyup)="handleuserlast($event)"
                      (keypress)="handleuserlast($event)"
                    />
                    <div
                      *ngIf="validitionlastName"
                      class="text-danger mt-1 error"
                    >
                      {{ validitionlastName }}
                    </div>
                  </div>
                  <div class="form-group fm-row mb-10 col-md-6">
                    <label for="exampleInputEmail1">Email</label>
                    <input
                      autocomplete="off"
                      placeholder="Student's Email"
                      type="email"
                      class="form-control"
                      #email="ngModel"
                      pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$"
                      required
                      (keypress)="handleEmail($event)"
                      (pointerdown)="handleEmail($event)"
                      (keyup)="handleEmail($event)"
                      [(ngModel)]="model.email"
                      name="email"
                      [ngClass]="{
                        'is-invalid': myForm.submitted && email.invalid
                      }"
                    />
                    <div *ngIf="validationseen" class="text-danger mt-1 error">
                      {{ validationseen }}
                    </div>
                  </div>
                  <div class="form-group fm-row col-md-6">
                    <label
                      for="exampleInputEmail1"
                      style="
                        position: relative !important;
                        bottom: 13px !important;
                      "
                    >
                      Have a Demo Access code?
                    </label>
                    <input
                      autocomplete="off"
                      placeholder="Enter Here"
                      type="text"
                      class="form-control"
                      #coupon="ngModel"
                      [(ngModel)]="model.coupon"
                      name="coupon"
                      (input)="onCouponCodeInput()"
                    />
                    <!-- <div *ngIf="Coupon == true" class="text-danger mt-1 error">
                      {{ validitionseencoupon }}
                    </div> -->
                  </div>

                  <!-- <div class="ml-3">
                    <span>
                      <input
                        type="checkbox"
                        class="click-h mr-2"
                        (change)="applyCoupon($event)"
                      />
                      I have an access code
                    </span>
                  </div> -->
                  <!-- *ngIf="!isApplyCouponCode" -->

                  <div
                    class="list-offer animate__animated animate__fadeInDown mt-2 col-md-12"
                    *ngIf="showPriceList"
                  >
                    <div
                      class="subscription-form d-flex flex-row justify-content-center text-center bx-blue mb-3"
                    >
                      <div
                        class="subscription-type pl-3 pr-3 m-2 cursor-pointer"
                        *ngFor="let priceitem of PriceList; let i = index"
                        [ngClass]="
                          selectedPrice == priceitem.priceStripeId
                            ? 'active'
                            : ''
                        "
                        (click)="AllData(priceitem.priceStripeId)"
                      >
                        <!-- [checked]="i === 0 ? true : false" -->
                        <input
                          type="radio"
                          name="priceId"
                          id="priceId"
                          value="priceId"
                          class="mr-2"
                          [checked]="
                            selectedPrice == priceitem.priceStripeId
                              ? true
                              : false
                          "
                          (change)="onRadioChange(priceitem)"
                        />
                        <span>{{ "$" + priceitem?.unit_amount }}</span
                        ><br />
                        <label for="monthly"
                          >{{
                            getPriceLabel(priceitem.recurring?.interval)
                          }}
                          Subscription</label
                        >

                        <div
                          *ngIf="priceitem?.unit_amount === 60"
                          class="mt-0 mb-1 off ml-2"
                        >
                          (Save 80%)
                        </div>
                        <!-- (change)="onRadioChange(priceitem)" -->

                        <!-- <input
                          type="radio"
                          name="priceId"
                          id="priceId"
                          value="priceId"
                          #priceId="ngModel"
                          [checked]="i == 0 ? model.priceId : false"
                          [(ngModel)]="model.priceId"
                        /> -->
                      </div>
                    </div>

                    <!-- <ul>
                    <li>
                
                    </li>
                </ul> -->
                  </div>
                  <!-- [ngClass]="{
                    'is-invalid': myForm.submitted && coupon.invalid
                  }"
                  maxlength="25"
                  (keyup)="handlecoupon($event)" -->
                  <!-- *ngIf="isApplyCouponCode" -->

                  <div
                    class="justify-content-between align-items-center col-md-12"
                  >
                    <div class="">
                      <div class="col-md-12 text-center pri-btn">
                        <input
                          type="checkbox"
                          class="click-h mr-2"
                          (click)="agreeCoupon()"
                        />
                        <span
                          >By using our service, you agree to our
                          <a (click)="privacypolicy()" class="pri-hover"
                            >Privacy Policy</a
                          ></span
                        >
                      </div>
                    </div>

                    <div class="text-center mt-3">
                      <tui-loader
                        style="display: inline-flex"
                        class="tui-space_right-2"
                        [showLoader]="showLoader"
                        [inheritColor]="true"
                        [overlay]="true"
                      >
                        <button
                          tuiButton
                          type="submit"
                          class="btn btn-primary page-btn m-0"
                          [disabled]="!(myForm.valid && Agree)"
                          [ngClass]="!myForm.valid ? 'cursor-not-allowed' : ''"
                        >
                          {{
                            isApplyCouponCode
                              ? "Create account"
                              : "Pay & Subscribe"
                          }}

                          <!-- Create account -->
                        </button>
                        <div class="col-md-12 text-center pri-btn mt-3 px-0">
                          Already have an account?
                           <a href="https://www.top5-v2.virtueanalytics.com/auth/signin?userType=STUDENT" target="_self">Login</a>
                         </div>
                      </tui-loader>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="signin" *ngIf="alreadyAccount == false">
              <form
                #accountForm="ngForm"
                autocomplete="false"
                (ngSubmit)="accountLogin(accountForm)"
              >
                <div class="Student Login pt-3 row">
                  <div class="form-group fm-row col-md-6">
                    <label for="Student Name">Username</label>
                    <input
                      autocomplete="false"
                      placeholder="User Name"
                      type="text"
                      class="form-control"
                      maxlength="50"
                      (keyup)="handleuserNAme($event)"
                      (keypress)="handleuserNAmeValue($event)"
                      [(ngModel)]="studentLogin.name"
                      name="name"
                      required
                    />

                    <div
                      *ngIf="validitionUSerName"
                      class="text-danger mt-1 error"
                    >
                      {{ validitionUSerName }}
                    </div>
                  </div>
                  <div
                    class="form-group fm-row mb-10 relative pass-icon col-md-6"
                  >
                    <label for="exampleInputEmail1">Password</label>
                    <input
                      autocomplete="nope"
                      placeholder="Password"
                      type="password"
                      (keyup)="handleuserPassword($event)"
                      [type]="hide ? 'password' : 'text'"
                      class="form-control"
                      #pass="ngModel"
                      required
                      [(ngModel)]="studentLogin.pass"
                      name="pass"
                      maxlength="50"
                    />
                    <svg
                      (click)="hide = !hide"
                      *ngIf="hide == true"
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 text-gray-500 cursor-pointer"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21"
                      />
                    </svg>
                    <svg
                      (click)="hide = !hide"
                      *ngIf="hide != true"
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 text-gray-500 cursor-pointer"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="2"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      />
                    </svg>
                    <div
                      *ngIf="validitionUSerPass"
                      class="text-danger mt-1 error"
                    >
                      {{ validitionUSerPass }}
                    </div>
                  </div>
                  <div
                    class=""
                    style="margin-left: 15px"
                    id="forgot-password-link"
                  >
                    <!-- Create Account -->
                    <a
                      id="create-hover"
                      style="text-decoration: none"
                      [routerLink]="['/home/ResetPassword']"
                      target="_blank"
                      >Forgot Password?
                    </a>
                  </div>
                  <div class="col-md-12 text-center">
                    <tui-loader
                      style="display: inline-flex"
                      class="tui-space_right-2"
                      [showLoader]="verifyshowLoader"
                      [inheritColor]="true"
                      [overlay]="true"
                    >
                      <button
                        tuiButton
                        type="submit"
                        class="btn btn-primary"
                        [disabled]="!accountForm.valid"
                        [ngClass]="
                          studentLogin.name == '' && studentLogin.pass == ''
                            ? 'cursor-not-allowed'
                            : ''
                        "
                        class="btn btn-primary page-btn m-0 verify-btn"
                      >
                        Sign in
                      </button>
                    </tui-loader>
                  </div>
                  <div class="col-md-12 text-center pri-btn mt-3 px-0">
                    By using our service, you agree to our
                    <a (click)="privacypolicy()">Privacy Policy</a>.
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fuild bg-light pt-5 pb-5 Small shadow feature-1">
    <div class="container py-2">
      <div class="text-center mb-4">
        <h1>Compare the Real Cost of College</h1>
      </div>
      <div class="row">
        <div class="col-md-3 text-center">
          <h2 class="text-black">
            <strong>100s</strong> of hours spent by families on colleges'
            websites
          </h2>
        </div>
        <div class="col-md-3 text-center">
          <h2>
            <strong>Cross-checking</strong> multiple tax forms to ascertain EFC
          </h2>
        </div>
        <div class="col-md-3 text-center">
          <h2 class="text-black">
            <strong>Dozens</strong> of forms to be filled to find out college
            costs
          </h2>
        </div>
        <div class="col-md-3 text-center">
          <h2 class="text-black">
            <strong>Weeks</strong> to collate the financial information from
            each college
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-2 pt-5">
    <div class="row feature-view d-flex align-items-center mb-4">
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/colleges-universities.jpg"
        />
      </div>
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">1500+ Colleges and Universities</h2>
          <p>
            Today, you would spend hours and hours to ascertain scholarships and
            aid available from different colleges for you. With Top5 you have
            access to pre-collated data from 1500+ colleges with more added
            every day, making the choice easier to make.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-4 pt-4">
    <div class="row feature-view d-flex align-items-center">
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">40+ Courses Supported</h2>
          <p>
            You could be keen to study physical education or you could be
            passionate about aeronautical engineering, you can select from over
            40+ courses offered at the institutions available in Top5Colleges.
          </p>
        </div>
      </div>
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/courses-supported.jpg"
          class="w-full"
        />
      </div>
    </div>
  </div>

  <div class="container mt-4 pt-4 mb-5">
    <div class="row feature-view d-flex align-items-center mt-5">
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/compare-award-letters.png"
          class="w-full"
        />
      </div>
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">Compare Award Letters</h2>
          <p>
            Already have Award letters from colleges, just upload them and let
            Top5Collleges use the proprietary AI technology to swift through the
            letters and give you tabulated information for comparison.
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="container mt-4 pt-4 mb-5">
    <div class="row feature-view d-flex align-items-center">
      <div class="col-md-7">
        <div class="mx-5">
          <h2 class="fet-head">Find the Out-of-Pocket Cost</h2>
          <p>
            The most difficult part about college tuition finance is finding the
            actual out-of-pocket cost of attending. With Top5Colleges this cost
            is discerned in big and bold on the results page for you to Choose
            Wisely!
          </p>
        </div>
      </div>
      <div class="col-md-5">
        <img
          src="https://cdn.virtueanalytics.com/cache/find-the-out-of-pocket-cost.jpg"
          class="w-full"
        />
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
